<div class="delivery-topic-feedback-view-part">
	<grid-content [setup]="setup()" [namedSize]="'TabContent'" [pageTabsGridSize]="pageTabsGridSize()"
		[rows]="topicFeedbacks()"></grid-content>
</div>